import PropTypes from "prop-types"
import { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { useLocation } from "react-router-dom"

import CountdownBanner from "areas/header/countdown-banner"
import { cn } from "styles/utils"

import DesktopNav from "./desktop-nav"
import MobileHeader from "./mobile-header"

const HeaderContent = ({ microbanner, secondMicroBanner }) => {
  const [sticky, setSticky] = useState(false)
  const headerRef = useRef()
  const rafRef = useRef()
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      rafRef.current = window.requestAnimationFrame(() => {
        if (headerRef.current) {
          setSticky(
            !location.pathname.includes("cart") &&
              window.pageYOffset >
                headerRef.current.getBoundingClientRect().height + 50
          )
        }
      })
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.cancelAnimationFrame(rafRef.current)
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  // const shouldSimplifyAboveFoldOnMobile =
  //   location.pathname.includes("/products/") && holdbackExp === 0

  return (
    <header
      className={cn(
        "backface-hidden border-b-grey-10 duration-400 sticky top-0 z-40 flex w-full flex-col bg-white transition-shadow",
        sticky ? "shadow-lg" : "shadow-none",
        location.pathname.includes("cart") && "tablet:static"
      )}
      ref={headerRef}
    >
      {/* {shouldSimplifyAboveFoldOnMobile ? (
        <>
          {secondMicroBanner && (
            <CountdownBanner
              isSecondMicroBanner
              microbanner={secondMicroBanner}
              showOnDesktop={false}
            />
          )}
          <CountdownBanner microbanner={microbanner} showOnMobile={false} />
        </>
      ) : (
        <CountdownBanner microbanner={microbanner} />
      )} */}
      <CountdownBanner microbanner={microbanner} />
      <MobileHeader />
      <DesktopNav />
      {secondMicroBanner && (
        <CountdownBanner
          isSecondMicroBanner
          microbanner={secondMicroBanner}
          // showOnMobile={!shouldSimplifyAboveFoldOnMobile}
        />
      )}
    </header>
  )
}

HeaderContent.propTypes = {
  // holdbackExp: PropTypes.number,
  microbanner: PropTypes.object,
  secondMicroBanner: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    // holdbackExp: state.experiment.holdback.variant_id,
    microbanner: state.sale.microbanner,
    secondMicroBanner: state.sale.second_microbanner,
  }
}

export default connect(mapStateToProps)(HeaderContent)
